export default __webpack_public_path__ + "static/media/Hellraiser.09fc5d6b.mp3";